import clsx from "clsx";
import { TextField } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import InputMask from "react-input-mask";
import { palette } from "../theme/palette";

const useStyles = makeStyles({
  textField: {
    width: "100%",
  },
  disabled: {
    pointerEvents: "none",
    "& input": {
      color: palette.typography.black.disabled,
    },
  },
});

export const MaskedTextField = ({
  mask = "",
  value,
  name,
  label,
  helperText,
  disabled,
  error,
  onChange = () => {},
}) => {
  const styles = useStyles();
  return (
    <InputMask
      className={disabled && styles.disabled}
      mask={mask}
      onChange={onChange}
      value={value || ""}
      disabled={disabled}
    >
      {() => (
        <TextField
          className={clsx(styles.textField, disabled && styles.disabled)}
          variant={"outlined"}
          label={label}
          name={name}
          error={!!error}
          helperText={error || helperText}
          FormHelperTextProps={{
            style: { marginLeft: "0px", marginBottom: "-0.5rem" },
          }}
        />
      )}
    </InputMask>
  );
};
